<div class="consent-gate">
  @if (consent.fetchFailed()) {
    <p id="ai-consent-load-error" class="consent-load-error">{{ 'aiReport.lbl_consent_load_error' | translate }}</p>
    <button type="button" id="ai-consent-retry" class="btn-retry" (click)="retry()">{{ 'aiReport.lbl_consent_retry' | translate }}</button>
  } @else if (consent.status() === null) {
    <p class="consent-loading">{{ 'aiReport.lbl_consent_loading' | translate }}</p>
  } @else {
    <h3 class="consent-title">{{ 'aiReport.lbl_consent_title' | translate }}</h3>
    <p class="consent-body">{{ 'aiReport.lbl_consent_body' | translate }}</p>
    <label class="consent-checkbox">
      <input type="checkbox" id="ai-consent-checkbox" [checked]="checked()" (change)="onCheckboxChange($event)" />
      {{ 'aiReport.lbl_consent_checkbox' | translate }}
    </label>
    @if (acceptError()) {
      <p id="ai-consent-accept-error" class="consent-accept-error">{{ 'aiReport.lbl_consent_accept_error' | translate }}</p>
    }
    <button type="button" id="ai-consent-continue" class="btn-continue" [disabled]="!checked() || accepting()" (click)="onAccept()">
      {{ 'aiReport.lbl_consent_continue' | translate }}
    </button>
  }
</div>
